import React from "react"

const PagesContext = React.createContext({
  token: null,
})

export default PagesContext
